import { wacToken } from "@/libraries/design/foundations";

export const ProTipIcon = () => {
    return (
        <svg
            width="88"
            height="88"
            viewBox="0 0 76 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
        >
            <path
                d="M60.5935 36.8029C60.9647 34.7229 61.1567 32.5181 61.1567 30.1757C61.1567 27.8333 60.9583 25.5677 60.5807 23.4621C58.3343 10.9373 49.6303 3.21893 37.4287 1.23173C35.3455 0.895727 33.1631 0.719727 30.8943 0.719727C28.6255 0.719727 26.2511 0.905327 24.0879 1.27013C11.8799 3.30853 3.19506 11.0109 0.939063 23.4621C0.558263 25.5645 0.359863 27.8045 0.359863 30.1757C0.359863 32.5469 0.555063 34.7229 0.926263 36.8029C3.16306 49.2413 11.8575 56.9565 24.0847 58.9949C26.2479 59.3565 28.5231 59.5453 30.8911 59.5453C33.2591 59.5453 35.3455 59.3725 37.4255 59.0333C49.6463 57.0493 58.3535 49.3117 60.5871 36.8029H60.5935Z"
                fill={wacToken("color.extended.lime600")}
            />
            <path
                d="M41.3296 29.9547L64.728 5.58032L73.3808 13.5931L39.3936 42.7675L23.3936 28.0251L31.7136 18.4187L41.3264 29.9579L41.3296 29.9547Z"
                fill={wacToken("color.secondary.navy")}
            />
            <path
                d="M60.5871 23.4621C59.9215 19.7693 58.6959 16.4861 56.9839 13.6509L41.3327 29.9549L31.7199 18.4157L23.3999 28.0221L39.3999 42.7645L60.7503 24.4381C60.7023 24.1085 60.6511 23.7821 60.5935 23.4589L60.5871 23.4621Z"
                fill={wacToken("color.secondary.navy")}
            />
        </svg>
    );
};
